import { FilasExcel, obtenerNombrePreguntaTipo, PreguntasTipoEnum } from "@shared/enums";
import { DatosEncuestaExportar } from "./DatosEncuestaExportar";
import { PreguntaDTO } from "@DTOS";

export abstract class PreguntaExportador {
    abstract puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean;
    public exportar(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string>[] {
        return [
            this.generarFilaPregunta(datosEncuesta),
            ...this.generarSubpreguntas(datosEncuesta),
            ...this.generarItemsPregunta(datosEncuesta)
        ];
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const pregunta = datosEncuesta.pregunta;
        const fila = new Map<FilasExcel, string>();
        fila.set(FilasExcel.PREGUNTA_ID, `${datosEncuesta.indice}`);
        fila.set(FilasExcel.TIPO_PREGUNTA, obtenerNombrePreguntaTipo(pregunta.tipo));
        fila.set(FilasExcel.TEXTO_PREGUNTA, pregunta.texto);
        fila.set(FilasExcel.ALEATORIO, pregunta.aleatorio ? "1" : "");
        fila.set(FilasExcel.REFERENCIA, pregunta.textoReferencia);
        fila.set(FilasExcel.ITEMS, "");
        fila.set(FilasExcel.PREGUNTA_SIGUIENTE, `${pregunta.siguientePregunta}`);
        fila.set(FilasExcel.KILLER, "");
        fila.set(FilasExcel.VISIBLE_SI,
            this.transformarACondicionExcel(pregunta.condiciones, datosEncuesta.itemsIdsAnteriores));
        fila.set(FilasExcel.MIN_MAX, this.generarMinMax(pregunta));
        fila.set(FilasExcel.CUSTOMER_ID, pregunta.idCliente);
        fila.set(FilasExcel.BLOQUE_ID, pregunta.idBloque != null ? `${datosEncuesta.bloqueIds.get(pregunta.idBloque)}` : "");
        return fila;
    }

    protected generarSubpreguntas(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string>[] {
        const pregunta = datosEncuesta.pregunta;
        const filasSubpreguntas: Map<FilasExcel, string>[] = [];
        if (pregunta.preguntas == null) {
            return filasSubpreguntas;
        }
        pregunta.preguntas.forEach((subpregunta, indiceSubpregunta) => {
            const fila = this.generarFilaPregunta({
                ...datosEncuesta,
                pregunta: subpregunta
            });
            fila.set(FilasExcel.PREGUNTA_ID, `${datosEncuesta.indice}.${indiceSubpregunta + 1}`);
            filasSubpreguntas.push(fila);
        });
        return filasSubpreguntas;
    }

    protected generarItemsPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string>[] {
        const pregunta = datosEncuesta.pregunta;
        if (this.esPreguntaSinItems(pregunta)) {
            return [];
        }
        const filasItems: Map<FilasExcel, string>[] = [];
        pregunta.items.forEach((item, indiceItem) => {
            const fila = new Map<FilasExcel, string>();
            fila.set(FilasExcel.PREGUNTA_ID, `${datosEncuesta.indice}.${(pregunta.preguntas != null ? pregunta.preguntas.length : 0) + indiceItem + 1}`);
            fila.set(FilasExcel.TIPO_PREGUNTA, "");
            fila.set(FilasExcel.TEXTO_PREGUNTA, "");
            fila.set(FilasExcel.ALEATORIO, "");
            fila.set(FilasExcel.REFERENCIA, "");
            fila.set(FilasExcel.ITEMS, item.texto);
            fila.set(FilasExcel.PREGUNTA_SIGUIENTE, `${item.preguntaSiguiente ?? ""}`);
            fila.set(FilasExcel.KILLER, item.esOpcionKiller ? "1" : "");
            fila.set(FilasExcel.VISIBLE_SI, item.condiciones != null ?
                this.transformarACondicionExcel(item.condiciones, datosEncuesta.itemsIdsAnteriores) : "");
            fila.set(FilasExcel.MIN_MAX, this.generarMinMax(pregunta));
            fila.set(FilasExcel.CUSTOMER_ID, "");
            fila.set(FilasExcel.BLOQUE_ID, "");
            filasItems.push(fila);
        });
        return filasItems;
    }

    private generarMinMax(pregunta: PreguntaDTO): string {
        let minMax = "";
        if (pregunta.minimo != null && pregunta.minimo !== 0) {
            minMax += `${pregunta.minimo}`;
        }
        if (pregunta.maximo != null && pregunta.maximo !== 0) {
            minMax += `;${pregunta.maximo}`;
        }
        if (pregunta.paso != null && pregunta.paso !== 0) {
            minMax += `;${pregunta.paso}`;
        }
        if (minMax.startsWith(";")) {
            minMax = `0${minMax}`;
        }
        return minMax;
    }

    private transformarACondicionExcel(condicion: string, itemsIdsAnteriores: Map<string, string>): string {
        const idsItems = Array.from(itemsIdsAnteriores.keys());
        let condicionParaExcel = condicion;
        idsItems.forEach(idItem => {
            if (condicionParaExcel.includes(idItem)) {
                condicionParaExcel = condicionParaExcel.replace(
                    new RegExp(idItem, "g"), itemsIdsAnteriores.get(idItem)!
                );
            }
        });
        return condicionParaExcel;
    }

    private esPreguntaSinItems(pregunta: PreguntaDTO): boolean {
        return [PreguntasTipoEnum.DATE_SELECT, PreguntasTipoEnum.FLOW_CHECKPOINT, PreguntasTipoEnum.MATRIX_RANGE,
            PreguntasTipoEnum.NUMERIC_TEXT, PreguntasTipoEnum.NUMERIC_IN_RANGE, PreguntasTipoEnum.TEXT]
            .includes(pregunta.tipo);
    }
}
